import { E164Number } from 'libphonenumber-js/types';
import React from 'react';
import PhoneInput from 'react-phone-number-input'
import 'react-phone-number-input/style.css'

interface PhoneNumberProps {
    onChage?: (e: string) => void,
    value: string
}

const InputPhoneNumber = (props: PhoneNumberProps) => {
    const { onChage, value } = props;
    return (
        <>
            <PhoneInput
                className='border-0 '
                defaultCountry={"ID"}
                onChange={(e: string) => onChage && onChage(e)}
                value={value} />
        </>
    );
};

export default InputPhoneNumber;